import React from 'react';
import { Forum } from '@mui/icons-material';
import { GREENING_AGENT_LABEL, GREENING_CHAT_TITLE } from './constants';

export type GreeningFabActionId = 'chat';

export interface GreeningFabActionDef {
  id: GreeningFabActionId;
  label: string;
  description?: string;
  icon: React.ReactNode;
  /** Reservado para ações futuras sem remover o slot do menu. */
  comingSoon?: boolean;
}

/** Menu do FAB — adicionar novas ações aqui (somente chat por enquanto). */
export const GREENING_FAB_ACTIONS: GreeningFabActionDef[] = [
  {
    id: 'chat',
    label: GREENING_CHAT_TITLE,
    description: `Tire dúvidas sobre esta norma com o agente ${GREENING_AGENT_LABEL}`,
    icon: <Forum sx={{ fontSize: 22 }} />,
  },
];

export const GREENING_FAB_MENU_HEADER = GREENING_AGENT_LABEL;
export const GREENING_FAB_MENU_SUBTITLE = 'Agente de Inteligência · legislação ambiental';

/** Cores de marca PV/PA/CTRE para o elemento flutuante e destaques de texto */
export const GREENING_BRAND = {
  green: '#009053',
  teal: '#2B92AC',
  /** CTRE — laranja PA (mesmo tom do ícone info legado) */
  orange: '#FFA52A',
} as const;
